var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1651_745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8968 28.6146C12.3775 28.5511 12.8631 28.6814 13.246 28.9764L15.0107 30.3306C15.5941 30.7787 16.4056 30.7787 16.9873 30.3306L18.8189 28.9242C19.1611 28.6619 19.5929 28.5462 20.0198 28.6032L22.3109 28.9047C23.0393 29.0008 23.7416 28.5951 24.0235 27.9155L24.905 25.784C25.0696 25.3848 25.3857 25.0686 25.7849 24.9041L27.9163 24.0224C28.5958 23.7422 29.0016 23.0382 28.9054 22.3098L28.6154 20.1017C28.5518 19.6209 28.6822 19.1353 28.9771 18.7524L30.3312 16.9875C30.7793 16.4041 30.7793 15.5926 30.3312 15.0108L28.925 13.1792C28.6626 12.837 28.5469 12.4051 28.604 11.9782L28.9054 9.68699C29.0016 8.95857 28.5958 8.25621 27.9163 7.9743L25.7849 7.09269C25.3857 6.9281 25.0696 6.61196 24.905 6.21271L24.0235 4.08122C23.7432 3.40168 23.0393 2.99592 22.3109 3.09206L20.0198 3.39353C19.5929 3.4522 19.1611 3.3365 18.8205 3.07576L16.9889 1.66943C16.4056 1.2213 15.5941 1.2213 15.0124 1.66943L13.1808 3.07576C12.8386 3.3365 12.4068 3.4522 11.9799 3.39679L9.68881 3.09532C8.96042 2.99917 8.25811 3.40494 7.97621 4.08448L7.09628 6.21597C6.93007 6.61359 6.61395 6.92973 6.21635 7.09595L4.08498 7.97593C3.40548 8.25784 2.99973 8.96019 3.09587 9.68862L3.39733 11.9798C3.45273 12.4068 3.33704 12.8386 3.07632 13.1792L1.67007 15.0108C1.22196 15.5942 1.22196 16.4058 1.67007 16.9875L3.07632 18.8192C3.33867 19.1614 3.45436 19.5932 3.39733 20.0202L3.09587 22.3114C2.99973 23.0398 3.40548 23.7422 4.08498 24.0241L6.21635 24.9057C6.61558 25.0703 6.9317 25.3864 7.09628 25.7857L7.97784 27.9171C8.25811 28.5967 8.96205 29.0025 9.69044 28.9063L11.8968 28.6146Z",
    stroke: "#F63C47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.666 16.6667L13.9993 20L21.3327 12.6667",
    stroke: "#F63C47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1651_745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP17);
export default __webpack_public_path__ + "static/media/p17.55006a88572eed6ddd2158025f90a3c5.svg";
export { ForwardRef as ReactComponent };